import Notification from 'element-ui/packages/notification';

export default class CoreNotify {
  constructor(parent) {
    this.$parent = parent;
  }

  message(data) {
    const type = data?.type || 'info';
    const title = data?.title || '';
    const message = this.$parent.language.get(data?.message || data);
    Notification({
      type,
      title,
      message,
    });
  }

  info(message, title = '') {
    this.message({
      type: 'info',
      title,
      message,
    });
  }

  warning(message, title = '') {
    this.message({
      type: 'warning',
      title,
      message,
    });
  }

  success(message, title = '') {
    this.message({
      type: 'success',
      title,
      message,
    });
  }

  error(message, title = '') {
    this.message({
      type: 'error',
      title,
      message,
    });
  }
}
